exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ni-list.ant-list {\n  border: 1px solid #D7D7DE;\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n.ni-list.ant-list.page-margin {\n  margin-bottom: 60px;\n}\n.ni-list.ant-list .ant-list-pagination {\n  width: 100%;\n  position: absolute;\n  margin: 24px 0px;\n}\n.ni-list.ant-list .ant-empty {\n  margin: 0;\n  font-size: 14px;\n  line-height: 14px;\n}\n.ni-list.ant-list .ant-empty .ant-empty-image {\n  display: none;\n}\n", ""]);

// exports
